import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../constants/path';
import { CONTEXT_ROOT } from '../../constants';

import { scrollToAnchor } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import HeadComponent from '../HeadComponent';
import { withTemplate } from '../template/withTemplate';
import { PrimaryTemplate } from '../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../breadcrumb/LocalizedBreadcrumbsItem';

import './LegalNoticePage.scss';

class LegalNoticePage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-mentionslegales">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.LEGAL_NOTICE_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.LEGAL_NOTICE_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_2}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>
                    {i18n.TEXT5_2}
                    <br />
                    {i18n.TEXT5_3}
                    <br />
                    {i18n.TEXT5_4}
                </p>
                <p>
                    {i18n.TEXT5_5}
                    <br />
                    {i18n.TEXT5_6}
                </p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <p>{i18n.TEXT6_2}</p>
                <p>{i18n.TEXT6_3}</p>
                <p>{i18n.TEXT6_4}</p>
                <p>{i18n.TEXT6_5}</p>
                <p>{i18n.TEXT6_6}</p>
                <p>{i18n.TEXT6_7}</p>
                <p>{i18n.TEXT6_8}</p>
                <p>{i18n.TEXT6_9}</p>

                <div id="personal-data" />
                <h3>{i18n.TITLE7}</h3>
                <p>
                    <u>{i18n.TEXT7_1}</u>
                </p>
                <p>{i18n.TEXT7_2}</p>
                <p>{i18n.TEXT7_3}</p>
                <p>{i18n.TEXT7_4}</p>
                <p>{i18n.TEXT7_5}</p>
                <p>{i18n.TEXT7_6}</p>
                <ul>
                    <li>{i18n.TEXT7_7}</li>
                    <li>{i18n.TEXT7_8}</li>
                </ul>
                <p>{i18n.TEXT7_9}</p>
                <p>{i18n.TEXT7_10}</p>
                <p>{i18n.TEXT7_11}</p>
                <p>{i18n.TEXT7_12}</p>
                <p>
                    <u>{i18n.TEXT7_13}</u>
                </p>
                <p>{i18n.TEXT7_14}</p>
                <p>{i18n.TEXT7_15}</p>
                <p>{i18n.TEXT7_16}</p>
                <p>
                    <u>{i18n.TEXT7_17}</u>
                </p>
                <p>{i18n.TEXT7_18}</p>
                <p>{i18n.TEXT7_19}</p>
                <ul>
                    <li>{i18n.TEXT7_20}</li>
                    <li>{i18n.TEXT7_21}</li>
                </ul>
                <p>{i18n.TEXT7_22}</p>
                <ul>
                    <li>{i18n.TEXT7_23}</li>
                    <li>{i18n.TEXT7_24}</li>
                    <li>{i18n.TEXT7_25}</li>
                </ul>
                <p>{i18n.TEXT7_26}</p>
                <p>{i18n.TEXT7_27}</p>
                <p>{i18n.TEXT7_28}</p>
                <p>{i18n.TEXT7_29}</p>

                <div id="cookie-policy" />
                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
                <p>
                    <u>{i18n.TEXT8_2}</u>
                </p>
                <p>{i18n.TEXT8_3}</p>
                <p>{i18n.TEXT8_4}</p>
                <p>
                    <u>{i18n.TEXT8_5}</u>
                </p>
                <p>{i18n.TEXT8_6}</p>
                <p>{i18n.TEXT8_7}</p>
                <p>
                    <b>{i18n.TEXT8_8}</b>
                </p>
                <p>{i18n.TEXT8_9}</p>

                <p>{i18n.TEXT8_21}</p>
                <p>
                    <b>{i18n.TEXT8_22}</b>
                </p>
                <p>{i18n.TEXT8_23}</p>
                <p>{i18n.TEXT8_24}</p>
                <p>{i18n.TEXT8_25}</p>
                <p>{i18n.TEXT8_26}</p>
                <p>{i18n.TEXT8_27}</p>
                <table>
                    <thead>
                        <tr>
                            <th>{i18n.TEXT8_28}</th>
                            <th>{i18n.TEXT8_29}</th>
                            <th>{i18n.TEXT8_30}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{i18n.TEXT8_31}</td>
                            <td>{i18n.TEXT8_32}</td>
                            <td>{i18n.TEXT8_33}</td>
                        </tr>
                        <tr>
                            <td>{i18n.TEXT8_34}</td>
                            <td>{i18n.TEXT8_35}</td>
                            <td>{i18n.TEXT8_36}</td>
                        </tr>
                        <tr>
                            <td>{i18n.TEXT8_37}</td>
                            <td>{i18n.TEXT8_38}</td>
                            <td>{i18n.TEXT8_39}</td>
                        </tr>
                    </tbody>
                </table>
                <p>{i18n.TEXT8_40}</p>
                <p>{i18n.TEXT8_41}</p>
                <p>{i18n.TEXT8_42}</p>
                <p>
                    <u>{i18n.TEXT8_53}</u>
                </p>
                <p>{i18n.TEXT8_54}</p>
                <p>
                    <b>{i18n.TEXT8_55}</b>
                </p>
                <p>{i18n.TEXT8_56}</p>
                <p>{i18n.TEXT8_57}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT8_58)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT8_59)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT8_60)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT8_61)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT8_62)}</p>
                <p>
                    <u>{i18n.TEXT8_63}</u>
                </p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT8_64)}</p>

                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>

                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>
            </main>
        );
    }
}

LegalNoticePage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.LEGAL_NOTICE
    };
}

export default withTemplate(connect(mapStateToProps)(LegalNoticePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/LegalNoticePage.js